import { useMemo } from 'react';

import { useResponsive } from '@sg/garnish';

import {
  DEFAULT_SCREEN_OPTIONS,
  SCREEN_HEADER_OPTIONS,
  type ScreenOptionsMap,
} from '../../../../constants';
import { useRouteTitles } from '../../../messages';

// ─────────────────────────────────────────────────────────────────────────────

export const useGiftCardsTabStackOptions = () => {
  const { currentBreakpoint } = useResponsive();

  const titles = useRouteTitles();

  // ─────────────────────────────────────────────────────────────────────

  const stackOptions = useMemo(
    () => ({
      ...DEFAULT_SCREEN_OPTIONS,
      ...SCREEN_HEADER_OPTIONS,
      headerShown: currentBreakpoint.isXS,
    }),
    [currentBreakpoint.isXS],
  );

  /// ─────────────────────────────────────────────────────────────────────

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: stackOptions,

      // ─── Individual Tabs ─────────────────────────────────────────────────

      Home: {
        title: titles.giftCardsTabTitle,
        customDocumentTitle: titles.giftCardsTabCustomDocumentTitle,
        headerShown: false,
      },
      Checkout: {
        title: titles.giftCardCheckoutTitle,
        customDocumentTitle: titles.giftCardCheckoutCustomDocumentTitle,
      },
      Confirmation: {
        title: titles.giftCardConfirmationTitle,
        customDocumentTitle: titles.giftCardConfirmationCustomDocumentTitle,
      },
      Redeem: {
        title: titles.redeemGiftCardTitle,
        customDocumentTitle: titles.giftCardRedemptionCustomDocumentTitle,
      },
    } satisfies ScreenOptionsMap;
  }, [
    stackOptions,
    titles.giftCardCheckoutTitle,
    titles.giftCardCheckoutCustomDocumentTitle,
    titles.giftCardConfirmationTitle,
    titles.giftCardConfirmationCustomDocumentTitle,
    titles.giftCardsTabTitle,
    titles.giftCardsTabCustomDocumentTitle,
    titles.redeemGiftCardTitle,
    titles.giftCardRedemptionCustomDocumentTitle,
  ]);
};
